import { HTMLAttributes } from "react";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

export interface CardBodyProps extends SpaceProps, HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const CardBody = styled.div.attrs<CardBodyProps>(() => ({ p: "24px" }))<CardBodyProps>`
  ${space}
`;

export default CardBody;
